/**
 * Authenticated app shell: Sidebar + Header + routed content (`<Outlet/>`) +
 * Footer. Owns the mobile sidebar open/close state.
 */
import { useState, type ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/Layout/Sidebar';
import Header from '@/components/Layout/Header';
import Footer from '@/components/Layout/Footer';

/** Layout wrapper for all protected routes. */
export default function AppLayout(): ReactElement {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex min-h-screen flex-col lg:pl-64">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-4 sm:p-6">
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
